import { Link } from "@mui/icons-material";
import { isLinkOk, isLinkError } from "@common/utils/devices/summary";
import { getStatus } from "./getStatus";
import { RealTimeItemMonitoring } from "@common/components/ListDetailViews/common/RealTimeStatus/type";
import { GetAggregatorControllerStatusConfig } from "../types";
import { getExtendedTooltip } from "./getExtendedTooltip";
import { monitoringSourceLabelMap } from "../constants";

export const getDeviceStatusByAggregatorController = ({
  device,
  lastUpdatedLabel,
  monitoringSource,
  isDeviceCard,
  canAITroubleshoot,
  t,
  getErrorMessage,
  onTroubleshootClick,
  tooltipAsText,
}: GetAggregatorControllerStatusConfig) => {
  const status = device?.detailedStatuses?.find(
    (status) => status.monitoringSource === monitoringSource
  );

  const linkStatus = getStatus(
    isLinkOk,
    isLinkError,
    device,
    status,
    canAITroubleshoot
  );

  const error =
    (typeof getErrorMessage === "function" &&
      getErrorMessage(monitoringSource, linkStatus)) ||
    "";

  const monitoringSourceLabel = t(monitoringSourceLabelMap[monitoringSource]);

  const tooltip =
    isDeviceCard || !tooltipAsText
      ? getExtendedTooltip(monitoringSourceLabel, lastUpdatedLabel, error)
      : error;

  const deviceStatusByAggregatorController: RealTimeItemMonitoring = {
    label: "Link",
    type: linkStatus === "troubleshooting" ? "button" : "indication",
    icon: <Link />,
    status: linkStatus,
    tooltip,
  };

  if (typeof onTroubleshootClick === "function") {
    deviceStatusByAggregatorController.onClick = () =>
      onTroubleshootClick(error);
  }

  let deviceStatusByAggregatorControllerLabel = t(
    monitoringSourceLabelMap[monitoringSource]
  );

  if (linkStatus === "success" || linkStatus === "error") {
    deviceStatusByAggregatorControllerLabel = device?.aggregator?.name || "";
  }

  return {
    deviceStatusByAggregatorController,
    deviceStatusByAggregatorControllerLabel,
  };
};
